import React from "react";
import { Row, Col, Typography } from "antd";
import 'antd/dist/antd.min.css';

const { Title } = Typography;

const PrivacyPolicyComponent = () => {
  return (
    <div style={{ width: "100%", padding: "40px 20px" }}>
      <Row>
        <Col md={4} xl={4}></Col>
        <Col md={16} xl={16}>
          <Title style={{ color: "#F6921E" }}>Privacy Policy</Title>
          <p style={{ color: "#667085", fontSize: "16px" }}>
            Last updated: May 2026
          </p>
          <br />
          
          <Title level={3}>What We Do With The Information We Gather</Title>
          <ul style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            <li>Internal record keeping</li>
            <li>Improve our products and services</li>
            <li>Send promotional emails about new products or offers</li>
            <li>Contact you for market research purposes</li>
            <li>Customize the website/app according to your interests</li>
          </ul>
          <br />

          <Title level={3}>Account Deletion Policy</Title>
          <p style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            Users of the ReadMark mobile application have the right to delete their account and 
            associated personal data at any time.
          </p>
          <br />

          <Title level={4}>How to Delete Your Account:</Title>
          
          <p style={{ color: "#667085", fontSize: "16px", fontWeight: "bold" }}>
            Option 1: In-App Deletion
          </p>
          <ul style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            <li>Open the app</li>
            <li>Navigate to the Profile page</li>
            <li>Click "Delete Account"</li>
            <li>Confirm your request</li>
          </ul>
          <br />

          <p style={{ color: "#667085", fontSize: "16px", fontWeight: "bold" }}>
            Option 2: Email Request
          </p>
          <p style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            Send an account deletion request to support@abhyaas.in with:
          </p>
          <ul style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            <li>Your registered email address</li>
            <li>Your account name</li>
          </ul>
          <br />

          <Title level={4}>Deletion Process:</Title>
          <p style={{ color: "#667085", fontSize: "16px", lineHeight: "1.6" }}>
            Once submitted, requests are reviewed and data is permanently deleted within 7 working 
            days of administrative approval. A confirmation email will be sent upon completion. 
            Please note that deleted data cannot be recovered.
          </p>
        </Col>
        <Col md={4} xl={4}></Col>
      </Row>
    </div>
  );
};

export default PrivacyPolicyComponent;
